const meetingDetails = selectedMeetings => {
  let details;
  if(selectedMeetings.length >= 1) {
    details = Object.assign(
      {}, 
      selectedMeetings[0],
      {
        start_time: selectedMeetings[0].start_time.replace(/am|pm/, ''),
        end_time: selectedMeetings[0].end_time.replace(/am|pm/, '')
      }
    );
  }
  else {
    details = {
      meeting_id: '',
      cohorts: [],
      teachers: [],
      meeting: {name: '-'},
      day_of_week: '-',
      start_time: '-',
      end_time: '-',
      durationString: '-'
    };
  }
  return details;
};

const getDefaultCards = (meetings, available_staff, studentCohort) => {
  return [
    {
      id: 'summary',
      meetingDetails: meetingDetails(meetings),
      meetings: meetings
    },
    { id: 'agenda' },
    Object.assign({ 
      id: 'students'
    }, studentCohort),
    {
      id: 'staff_availability',
      teachers: available_staff
    },
    { id: 'facilities' }
  ];
};

export default function inspectorCards({meetings, teachers, days, available_staff, studentCohort}) {
  let cards = getDefaultCards(meetings, available_staff, studentCohort);
  cards.forEach(card => {
    card.open = true
  });
  return cards;
};


/** WEBPACK FOOTER **
 ** ./src/js/selectors/inspector_cards.js
 **/